import { Component, computed, effect, ElementRef, inject, signal, Signal, ViewChild, WritableSignal } from '@angular/core';
import { LogoComponent } from '../../shared/logo/logo.component';
import { ActionButtonsComponent } from './action-buttons/action-buttons.component';
import { RelatedPreviewsComponent } from './related-previews/related-previews.component';
import { DvmService } from '@services/dvm.service';
import { MinimapComponent } from './minimap/minimap.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { SearchComponent } from '../topbar/navigation/search/search.component';
import { MenuButtonsComponent } from '../topbar/menu/menu-buttons/menu-buttons.component';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';
import anime from 'animejs';
import { BenefitsButtonComponent } from "../topbar/benefits/benefits-button/benefits-button.component";
import { VenueLayoutButtonComponent } from '../topbar/venue-layout/venue-layout-button/venue-layout-button.component';
import { VenueLayoutService } from '@services/venue-layout.service';
import { ViewerRouteParamsService } from '@services/viewer-route-params.service';
import { UiService } from '@services/ui.service';

@Component({
    selector: 'app-footer',
    imports: [
        SearchComponent,
        MenuButtonsComponent,
        MinimapComponent,
        RelatedPreviewsComponent,
        LogoComponent,
        ActionButtonsComponent,
        DisclaimerComponent,
        BenefitsButtonComponent,
        VenueLayoutButtonComponent
    ],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css'
})
export class FooterComponent {

  // VIEW CHILDS
  @ViewChild('footerContainer', { static: true })
  private readonly footerContainer!:  ElementRef<HTMLElement>;

  // SERVICES
  private readonly dvmService:        DvmService               = inject(DvmService);
  private readonly routeParams:       ViewerRouteParamsService = inject(ViewerRouteParamsService);
  protected readonly venueLayout:     VenueLayoutService       = inject(VenueLayoutService);
  private readonly uiService:         UiService                = inject(UiService);

  // GLOBAL STATE
  protected readonly view:            Signal<AppViews|null> = this.dvmService.view;
  protected readonly AppViews:        typeof AppViews       = AppViews;
  protected readonly hyperlinkMode:   boolean               = this.routeParams.hasViewId;
  protected readonly showLogo:        Signal<boolean>       = computed((): boolean => this.uiService.uiConfig().LogoDisplay.enabled);

  // COMPONENT STATE
  protected readonly hideElement:     WritableSignal<boolean> = signal(false);

  private readonly fullscreenChange = effect((): void => {
    this.toggleVisibility(!this.dvmService.isFullscreen());
  });

  /**
   * Muestra u oculta el footer dependiendo del estado de la variable show.
   * Si hideElement es true, significa que el footer está oculto y no se puede mostrar, por ello si show es true, revertimos este estado
   * antes de la animación. 
   * @param {boolean} show 
   */
  private toggleVisibility(show: boolean): void {
    if (this.hyperlinkMode || !this.footerContainer) return;

    if(show && this.hideElement()) this.hideElement.set(false);

    anime({
      targets:  this.footerContainer.nativeElement,
      opacity:  show ? 1 : 0,
      easing:   'easeInOutQuad',
      duration: 300,
      complete: (): void => { if(!show && !this.hideElement()) this.hideElement.set(true); },
    })

  }


}
